import { AuthState } from './types';

export const state = (): AuthState => initialState();

export const initialState = (): AuthState => ({
  account: null,
  azureData: undefined,
  isUserInAzureAdminGroup: undefined,
  userAdminGroups: [],
  accountId: undefined,
  error: false,
});
